import { isEmpty } from 'lodash';

import regexMap from '../constants/regex-map';

/**
 * @param {String} value - email entered
 * @return {String} copyID of error message, if validation fails
 */
export function genericEmail(value) {
  if (isEmpty(value)) {
    return 'APP_VALIDATION_EMAIL_EMPTY';
  } else if (!regexMap.IS_EMAIL.test(value)) {
    return 'APP_VALIDATION_EMAIL_INVALID';
  }
}


export function birthdayDate(value) {
  if (isEmpty(value) || typeof value !== 'string') {
    return 'PAX_VALIDATION_DOB';
  }
}